import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import InstallationManual from "./pages/InstallationManual";

export default function App() {
    return (
        <BrowserRouter>
            <div className="App min-h-screen bg-[#0a0a0b] text-white">
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/installation-manual" element={<InstallationManual />} />
                </Routes>
                <Footer />
            </div>
        </BrowserRouter>
    );
}
